import React from 'react';
import { Link } from 'react-router-dom';
import '../css/featureGate.css';

/**
 * Hiển thị khi người cao tuổi chưa có gói / chưa liên kết — thay cho lỗi API thô.
 */
export default function MembershipRequiredView({
  compact = false,
  reason = 'membership',
  subtitle,
}) {
  const isNotLinked = reason === 'not_linked';
  const isPremium = reason === 'premium';

  const title = isNotLinked
    ? 'Chưa liên kết gia đình'
    : isPremium
      ? 'Cần gói Nâng cao'
      : 'Chức năng yêu cầu mua gói thành viên';

  const message = subtitle || (isNotLinked
    ? 'Vui lòng liên kết người cao tuổi và người thân bằng mã liên kết trước khi sử dụng.'
    : isPremium
      ? 'Tính năng này chỉ có trong gói Nâng cao. Nâng cấp để tiếp tục.'
      : 'Người thân cần mua gói Cơ bản hoặc Nâng cao cho người cao tuổi này để mở khóa tính năng.');

  const primaryLink = isNotLinked ? '/my-relatives' : '/membership';
  const primaryLabel = isNotLinked ? 'Liên kết ngay' : 'Mua ngay';

  return (
    <div className={`tamcare-feature-lock ${compact ? 'tamcare-feature-lock--compact' : ''}`}>
      <div className="tamcare-feature-lock__icon">
        <i className="fa-solid fa-lock" />
      </div>
      <h2>{title}</h2>
      <p>{message}</p>
      <div className="tamcare-feature-lock__actions">
        <Link to={primaryLink} className="tamcare-feature-lock__btn tamcare-feature-lock__btn--primary">
          {primaryLabel}
        </Link>
        {!isNotLinked && (
          <Link to="/my-relatives" className="tamcare-feature-lock__btn tamcare-feature-lock__btn--ghost">
            Quản lý gia đình
          </Link>
        )}
      </div>
    </div>
  );
}

export function MembershipRequiredPage({ children, compact }) {
  return (
    <div className="container" style={{ padding: compact ? '24px' : '48px 24px' }}>
      {children}
    </div>
  );
}
